import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
import { fetchBecomeMemberBanner, fetchBecomeMemberFrom, fetchFormRequirement, fetchMemberShipType, getToken } from "../api/MemberApi";
import { dynamicFailed } from "../hooks/useToast";
import MemberBanner from "../components/member/MemberBanner";
import { IBannerData, IBecomeMemberFromData, IFormRequirement, IMemberShipType } from "../exports/interfaces";
import BecomeMemberForm from "../components/member/BecomeMemberForm";

const BecomeMember = () => {
  const { setLoading } = useLoader();
  const [becomeMememberBannerData, setBecomeMememberBannerData] = useState<
    IBannerData[]
  >([]);
  const [becomeMemberData, setBecomeMememberData] = useState<IBecomeMemberFromData[]>([]);
  const [membershipType, setMembershipType] = useState<IMemberShipType[]>([]); 
  const [formRequirement, setFormRequirement] = useState<IFormRequirement[]>([]);
  const [token, setToken] = useState<string>("");
  useEffect(() => {
    setLoading(true);
      Promise.all([fetchBecomeMemberBanner(), fetchBecomeMemberFrom(), getToken(), fetchMemberShipType(), fetchFormRequirement()])
        .then(([becomeMemberBannerData, becomeMemberData, tokenData, memberShipTypeData, formRequirementData]) => {
          setBecomeMememberBannerData(becomeMemberBannerData);
          setBecomeMememberData(becomeMemberData);
          setToken(tokenData[0]?.attributes?.Token);
          setMembershipType(memberShipTypeData);
          setFormRequirement(formRequirementData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          dynamicFailed("Server Error");
        });
  }, [becomeMememberBannerData.length, setLoading]);
  return (
    <>
      <MemberBanner becomeMememberBannerData={becomeMememberBannerData} />
      <BecomeMemberForm becomeMemberData={becomeMemberData} token={token} membershipType={membershipType} formRequirement={formRequirement}/>
    </>
  );
};

export default BecomeMember;
